import React from 'react';

import { useTranslation } from 'react-i18next';

import { SupportPage } from '@pages/support';

import { Button } from '@components/button';

import { Faq } from './components/faq';
import * as Styled from './info.styled';

const Info = () => {
	const { t } = useTranslation('main');
	const [activeTab, setActiveTab] = React.useState<string>('faq');

	return (
		<Styled.Wrapper>
			<Styled.SwitchRow>
				<Styled.ButtonWrapper>
					<Button onClick={() => setActiveTab('faq')} color={activeTab === 'faq' ? 'primary' : 'dark'} variant='round'>
						{t('faq')}
					</Button>
				</Styled.ButtonWrapper>
				<Styled.ButtonWrapper>
					<Button
						onClick={() => setActiveTab('help')}
						color={activeTab === 'help' ? 'primary' : 'dark'}
						variant='round'
					>
						{t('help')}
					</Button>
				</Styled.ButtonWrapper>
			</Styled.SwitchRow>
			{activeTab === 'faq' && <Faq isHelpSectionVisible={false} />}
			{activeTab === 'help' && <SupportPage />}
		</Styled.Wrapper>
	);
};

export default Info;
